import { ObjectValues } from "@/src/shared/types/objectValues";
import type { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type { DSAriaLabelProps, DSStatefulProps } from "@/src/design_system/shared/types/props";

export const DS_INLINE_TOKEN_VARIANT = {
  Default: "default",
  Raised: "raised",
  Primary: "primary",
  Neutral: "neutral",
  Danger: "danger",
  Ghost: "ghost",
} as const;

export const DS_INLINE_TOKEN_GROUP_EDGE = {
  Solo: "solo",
  Start: "start",
  Middle: "middle",
  End: "end",
  NoPadding: "noPadding",
} as const;

export type DSInlineTokenVariant = ObjectValues<typeof DS_INLINE_TOKEN_VARIANT>;
export type DSInlineTokenGroupEdge = ObjectValues<typeof DS_INLINE_TOKEN_GROUP_EDGE>;

export type DSInlineTokenProps = Pick<DSStatefulProps, "disabled"> &
  Pick<DSAriaLabelProps, "ariaLabel"> & {
    text: string;
    variant?: DSInlineTokenVariant;
    groupEdge?: DSInlineTokenGroupEdge;
    prefixIcon?: DSIconName;
    avatarUrl?: string;
    flag?: DSFlagName;
    selected?: boolean;
    description?: string;
  };
